<div class="dialog-deleteAsset">
    <h1 mat-dialog-title class="dialog-deleteAsset__title">Warning</h1>
    <div mat-dialog-content class="dialog-deleteAsset__content">
        <span class="label">{{ data.asset.displayName }}</span> <br />
        <p>
            This activity is assigned to students. If you delete this activity,
            students will still have access to the corresponding assignments,
            but you will not be able to assign this activity again.
        </p>

        Are you sure you want to delete this activity?
    </div>
    <div mat-dialog-actions class="dialog-deleteAsset__actions">
        <button mat-button type="button" (click)="close(true)">
            <mat-icon color="primary">thumb_up</mat-icon>
            <span>Yes</span>
        </button>
        <button mat-button type="button" (click)="close(false)">
            <mat-icon color="warn">thumb_down</mat-icon>
            <span>No</span>
        </button>
    </div>
</div>
